// extracted by css-extract-rspack-plugin
export default {"root":"root-FZH9Dv"};